import { render, staticRenderFns } from "./ConnectWeightTable.vue?vue&type=template&id=1159dc47&scoped=true&"
import script from "./ConnectWeightTable.vue?vue&type=script&lang=js&"
export * from "./ConnectWeightTable.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWeightTable.vue?vue&type=style&index=0&id=1159dc47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159dc47",
  null
  
)

export default component.exports